(function () {
  var root = document.querySelector('[data-dwt-filter]');
  if (!root || !window.fetch) return;
  var input = root.querySelector('[data-dwt-input]');
  var box = root.querySelector('[data-dwt-suggest]');
  var form = root.querySelector('form');
  var timer, last = 0;

  function closeBox() { box.hidden = true; box.textContent = ''; }

  function allLink(q) {
    var a = document.createElement('a');
    a.className = 'dwt-suggest__all';
    a.href = form.getAttribute('action') + '?type=article&options%5Bprefix%5D=last&q=' + encodeURIComponent(q);
    a.textContent = 'Alle Ergebnisse anzeigen';
    return a;
  }

  function show(items, q) {
    box.textContent = '';
    if (!items.length) {
      var p = document.createElement('p');
      p.textContent = 'Kein Artikel gefunden. Versuche ein anderes Wort.';
      box.appendChild(p);
    } else {
      items.forEach(function (it) {
        var a = document.createElement('a');
        a.href = it.url;
        if (it.image) {
          var im = document.createElement('img');
          im.src = it.image + (it.image.indexOf('?') > -1 ? '&' : '?') + 'width=96';
          im.alt = '';
          a.appendChild(im);
        }
        var s = document.createElement('span');
        s.textContent = it.title;
        a.appendChild(s);
        box.appendChild(a);
      });
      box.appendChild(allLink(q));
    }
    box.hidden = false;
  }

  input.addEventListener('input', function () {
    clearTimeout(timer);
    var q = input.value.trim();
    if (q.length < 2) { closeBox(); return; }
    timer = setTimeout(function () {
      var n = ++last;
      fetch('/search/suggest.json?q=' + encodeURIComponent(q) + '&resources%5Btype%5D=article&resources%5Blimit%5D=6')
        .then(function (r) { return r.json(); })
        .then(function (d) { if (n === last) show(d.resources.results.articles || [], q); })
        .catch(closeBox);
    }, 200);
  });
  input.addEventListener('keydown', function (e) { if (e.key === 'Escape') closeBox(); });
  document.addEventListener('click', function (e) { if (!form.contains(e.target)) closeBox(); });

  if (!root.hasAttribute('data-dwt-ajax')) return;
  var results = document.querySelector('[data-dwt-results]');
  if (!results) return;

  function load(url, push, scroll) {
    results.classList.add('is-loading');
    fetch(url).then(function (r) { if (!r.ok) throw 0; return r.text(); }).then(function (html) {
      var d = new DOMParser().parseFromString(html, 'text/html');
      var nr = d.querySelector('[data-dwt-results]');
      if (!nr) throw 0;
      nr.querySelectorAll('.sr-animate').forEach(function (el) { el.classList.remove('sr-animate'); });
      nr.querySelectorAll('img').forEach(function (im) { im.setAttribute('loading', 'eager'); });
      results.innerHTML = nr.innerHTML;
      [['[data-dwt-title]'], ['[data-dwt-chips]'], ['[data-dwt-count]']].forEach(function (s) {
        var a = document.querySelector(s[0]), b = d.querySelector(s[0]);
        if (a && b) a.innerHTML = b.innerHTML;
      });
      document.title = d.title;
      if (push) history.pushState({ dwt: 1 }, '', url);
      results.classList.remove('is-loading');
      if (scroll) root.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }).catch(function () { location.href = url; });
  }

  document.addEventListener('click', function (e) {
    if (e.defaultPrevented || e.button || e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) return;
    var a = e.target.closest && e.target.closest('a');
    if (!a) return;
    var chip = a.classList.contains('dwt-chip') && root.contains(a);
    var page = a.closest('.pagination-wrapper') && results.contains(a);
    if (!chip && !page) return;
    e.preventDefault();
    load(a.href, true, !!page);
  });
  window.addEventListener('popstate', function () { load(location.href, false, false); });
})();
